import React from 'react'
import { Route, Redirect } from 'react-router-dom'



export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        localStorage.getItem('authen')
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/signin', state: { from: props.location } }} />
    )} />
);

export const PrivateRouteWithParams = ({ component: Component, ...rest }) => {
    //console.debug("PrivateRouteWithParams > rest", rest);
    //const authenData = localStorage.getItem('authen');
    //return (<Route {...rest}
    //    render={(props) => {
    //        console.debug("PrivateRouteWithParams > Route.render() > props", props);
    //        return <Component {...props} />
    //    }}
    ///>);
    return <Route {...rest} render={props => (
        localStorage.getItem('authen')
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/signin', state: { from: props.location } }} />
    )} />
}


export const PrivateRoute_Admin = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => (
        (localStorage.getItem('RoleID') === "5" || localStorage.getItem('RoleID') === '3' || localStorage.getItem('RoleID') === '6')
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    )} />
);
